import {EventSidebar} from 'organization/Event/Sidebar'
import DashboardPage from 'organization/theme/DashboardPage'
import Modals from 'organization/theme/Modals'
import React from 'react'
import {Header} from 'organization/theme/Header'

export default function EventPage(props: {
  children: React.ReactElement
  modals?: React.ReactElement
}) {
  return (
    <DashboardPage
      modals={<Modals modals={props.modals} />}
      sidebar={<EventSidebar />}
      header={<Header eventHeader={true} />}
    >
      {props.children}
    </DashboardPage>
  )
}
